<div class="add-card">
  <img class="add-card__icon" src="assets/icons/gift_icon.png" alt="" />
  <div class="add-card__text">
    <span class="add-card__title">{{ card?.title }}</span>
    <span class="add-card__help" [innerHTML]="card?.helpText | safe: 'html'"></span>
  </div>
  <s-polaris-button variant="primary" (pressed)="actionPressed.emit()">{{ card?.buttonLabel }}</s-polaris-button>
</div>
